import React, { ReactElement } from 'react';
import { Col, Row } from 'idsk-react-components';
import './PripomienkaDetailRow.scss';

interface Props {
  header: string;
  data: string | number;
}

const PripomienkaDetailRow = ({ header, data }: Props): ReactElement => data != null && (
  <Row className="pripomienka-detail-row">
    <Col width="one-quarter">
      <span className="information-header">{header}</span>
    </Col>
    <Col width="three-quarters">
      <p className="pripomienka-detail-row-text">{data}</p>
    </Col>
  </Row>
);

export default PripomienkaDetailRow;
